import axios from 'axios';
import router from '@/router/index.js';
import store from '@/store';
import { Message } from 'element-ui'

//是否开发环境
let isDevelopment = false;
let baseUrl = 'https://exhibitor.apichina.com.cn/pc/';

// 创建一个axios实例
const service = axios.create({
    baseURL: baseUrl, // url = base url + request url
    withCredentials: false, // send cookies when cross-domain requests
    timeout: 10000 // request timeout 10s
});

// 请求拦截器
service.interceptors.request.use(config => {
    // do something before request is sent
    const token = store.state.token;
    // 如果当前存有token,就加在请求头上
    if (token) {
        config.headers['token'] = `${token}`;
    }
    return config;
}, error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(response => {
    //do something before response
    if (response.status >= 200 && response.status <= 210) {
        if (response.data.code == 1) {
            return response.data;

        } else if (response.data.code == -1 || response.data.code == 4001) {
            //登录失效回到登录页面
            Message.warning('登录失效，请重新登录！');
            setTimeout(function () {
                router.replace({
                    path: '/login',
                })
            }, 1000)
        } else {
            Message.error(response.data.msg);
            return Promise.reject(new Error(response.data.msg));
        }
    } else {
        //不走
    }
},
    error => {
        console.log('err' + error); // for debug
        return Promise.reject(error);
    })

export default service;